import {tns} from 'tiny-slider'

import EmblaCarousel from 'embla-carousel'

const slider = () => {
    const sliderContainers = document.querySelectorAll('.search-internet-po-adresu__providers-slider__wrapper-items');

    sliderContainers.forEach(sliderContainer => {
        if (sliderContainer && window.innerWidth >= 1400) {
            const containerWidth = sliderContainer.offsetWidth;
            const cardWidth = containerWidth / 5 - 15;

            const slider = tns({
                container: sliderContainer,
                items: 5,
                slideBy: 1,
                controls: false,
                nav: false,
                loop: false,
                gutter: 15,
                mouseDrag: true,
                fixedWidth: cardWidth,
                controlsPosition: "bottom",
                preventActionWhenRunning: false,
                speed: 600,
                touch: false,
            });

            const prevBtn = document.querySelector('.providers-slider-controls__prev-arrow');
            const nextBtn = document.querySelector('.providers-slider-controls__next-arrow');

            prevBtn.addEventListener('click', () => slider.goTo('prev'));
            nextBtn.addEventListener('click', () => slider.goTo('next'));

            const updateButtons = () => {
                const info = slider.getInfo();

                if (info.index === 0) {
                    prevBtn.style.opacity = '0';
                    prevBtn.disabled = true;
                    prevBtn.visibility = 'hidden'
                } else {
                    prevBtn.style.opacity = '1';
                    prevBtn.disabled = false;
                }

                if (info.index >= info.slideCount - info.items) {
                    nextBtn.style.opacity = '0';
                    nextBtn.disabled = true;
                } else {
                    nextBtn.style.opacity = '1';
                    nextBtn.disabled = false;
                }
            }

            updateButtons();

            slider.events.on('indexChanged', updateButtons);
        }
    })
}

document.addEventListener('DOMContentLoaded', slider);

window.addEventListener('resize', () => {
    // Добавляем debounce чтобы не вызывать слишком часто
    clearTimeout(window.resizingFinished);
    window.resizingFinished = setTimeout(slider, 200);
});


const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
    const togglePrevNextBtnsState = () => {
        if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
        else prevBtn.setAttribute('disabled', 'disabled')

        if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
        else nextBtn.setAttribute('disabled', 'disabled')
    }

    emblaApi
        .on('select', togglePrevNextBtnsState)
        .on('init', togglePrevNextBtnsState)
        .on('reInit', togglePrevNextBtnsState)

    return () => {
        prevBtn.removeAttribute('disabled')
        nextBtn.removeAttribute('disabled')
        console.log(prevBtn);

    }
}

const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    const scrollPrev = () => {
        emblaApi.scrollPrev()
    }
    const scrollNext = () => {
        emblaApi.scrollNext()
    }
    prevBtn.addEventListener('click', scrollPrev, false)
    nextBtn.addEventListener('click', scrollNext, false)

    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
        emblaApi,
        prevBtn,
        nextBtn
    )

    return () => {
        removeTogglePrevNextBtnsActive()
        prevBtn.removeEventListener('click', scrollPrev, false)
        nextBtn.removeEventListener('click', scrollNext, false)
    }
}


const OPTIONS = {align: 'start', dragFree: true}

const emblaNodes = document.querySelectorAll('.embla')

emblaNodes.forEach(emblaNode=> {
    const viewportNode = emblaNode.querySelector('.embla__viewport')
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev')
    const nextBtnNode = emblaNode.querySelector('.embla__button--next')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS)

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode
    )

    emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
})
